export default "__VITE_ASSET__61ede512__"